import { useAppState } from '@/hooks/useAppState';
import { useMobileAppState } from '@/hooks/useMobileAppState';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { ReactNode } from 'react';
import { Main } from './Main';

export interface StandaloneMainProps extends StandaloneComponentProps<typeof Main> {
  content?: ReactNode;
}

const staticPages = ['kontakta-oss', 'om-oss', 'om-cookies', 'nyhetsbrev', 'tipsa-oss', 'lasarpanelen'];

export const StandaloneMain: StandaloneComponent<StandaloneMainProps> = ({ content, ...props }) => {
  const [{ publishedUrl }] = useAppState();
  const { isMobileApp } = useMobileAppState();

  const isStaticPage = staticPages.some((page) => publishedUrl?.startsWith(`/${page}`));

  return (
    <Main data-mobile-app={isMobileApp ? '' : undefined} data-page={isStaticPage ? 'static' : undefined} {...props}>
      {content}
    </Main>
  );
};
